import React, { useState, useEffect } from 'react';

import MoreInfo from "../components/MoreInfo";
import '../styles/views/formuleSurMesure.css';
import PositifPoint from "../components/PositifPoint";
import Process from '../components/Process';
import MockupTab from '../components/MockupTab';

import img_fiole from '../assets/img/formule_intro_fiole.png';
import img_packaging from '../assets/img/formule_packaging.png';

//icon process
import formule_standard from "../assets/icons/formule_standard.png";
import prod from "../assets/icons/prod.png";
import conditionnement from "../assets/icons/conditionnement.png";
import envoi from "../assets/icons/envoi.png";
import OtherProduct from '../components/OtherProduct';

//icon otherProduct
import probiotique from "../assets/icons/homepage_probiotique.png";
import niosome from "../assets/icons/homepage_niosome.png";

//icon carousel
import icon_arrow_forward from '../assets/icons/arrow_forward.svg';
import icon_arrow_back from '../assets/icons/arrow_back.svg';

import marque_blanche_mobile from "../assets/icons/img-marque-blanche-mobile.png"

export default function FormuleMarqueBlanche() {

    const [isMobile, setIsMobile] = useState(0);
    const [isCarousel, setIsCarousel] = useState(0);
    const [currentIndexProcess, setCurrentIndexProcess] = useState(0);

    const handlePrevProcess = () => {
        setCurrentIndexProcess((prevIndex) =>
            prevIndex === 0 ? process.length - 1 : prevIndex - 1
        );
    };

    const handleNextProcess = () => {
        setCurrentIndexProcess((prevIndex) =>
            prevIndex === process.length - 1 ? 0 : prevIndex + 1
        );
    };

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 1050);
            setIsCarousel(window.innerWidth <= 1050)
        };

        handleResize();
        window.addEventListener("resize", handleResize);

        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const downloadUrl = "/catalogue.pdf"

    const downloadFile = () => {
        const a = document.createElement("a");
        a.href = downloadUrl;
        a.download = downloadUrl.split('/').pop();
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    };

    const content = [
        ["Time saving", "The formulations are already developed, reducing the time needed for research and development."],
        ["Cost reduction", "No investment in production or R&D infrastructure."],
        ["Quality assurance", "Our laboratory complies with high quality standards (HACCP, GMP)."],
        ["Flexibility", "The ability to adapt the packaging and design to suit your brand image."],
        ["quick to market", "With ready-to-use products, you can launch your range quickly."]
    ]

    const categories = [
        {
            title: "Liposomes",
            subtitle: "Extraits de plantes vitamines - minéraux",
            type: "liposome",
            link: "*",
        },
        {
            title: "Niosomes",
            subtitle: "cosmétiques",
            type: "niosome",
            link: "*",
        },
        {
            title: "Probiotiques & postbiotiques",
            subtitle: "",
            type: "probiotique",
            link: "*",
        },
    ];

    const process = [
        [
            formule_standard,
            "choice of a standard formula",
            "Access a range of pre-established, tested and validated formulas, ready for rapid market launch. These formulas meet the market's main health and well-being needs."
        ],
        [
            prod,
            "production",
            "Thanks to our certified infrastructure, we control high-quality production. Adapted to your volumes, it guarantees products that  comply with standards and are rigorously controlled."
        ],
        [
            conditionnement,
            "personalised packaging",
            "In pillboxes, blister packs, sachets and bottles, we customise the packaging to reflect your brand  and meet your customers' expectations, while optimising the preservation of active ingredients."
        ],
        [
            envoi,
            "product shipment",
            "We ensure fast, secure delivery, whether to distribution centres or directly to the point of sale, for efficient distribution."
        ]
    ]

    useEffect(() => {
        const handleResize = () => {
        };

        handleResize();
        window.addEventListener("resize", handleResize);

        return () => window.removeEventListener("resize", handleResize);
    }, []);

    return (
        <div>
            <div className="formule_global-container">
                <section className="formule_intro-container-global">
                    {isMobile ? (
                        <div className='formule_intro-container'>
                            <h1 className="formule_intro-title">
                                <label className="bold formule_font-50">OUR WHITE-LABEL </label> <br />
                                <label className='orange-color'>PACKAGE</label>
                            </h1>
                            <MoreInfo
                                label={"Request our catalogue"}
                                link={"download"}
                            />
                            <h2 className="formule_intro-subtitle"><label className="orange-color"> Turnkey</label> products</h2>
                            <article className="formule_intro-text">
                                Our white-label formulas offer a quick and easy solution  for incorporating high-quality food supplements and cosmetics into your catalogue.By opting for this solution, you gain access to pre-formulated, tried-and-tested products, ready to be marketed under your own brand.
                            </article>
                        </div>
                    ) : (
                        <div className='formule_intro-container'>
                            <h1 className="formule_intro-title">
                                <label className="bold formule_font-50">OUR WHITE-LABEL </label> <br />
                                <label className='orange-color'>PACKAGE</label>
                            </h1>
                            <MoreInfo
                                label={"Request our catalogue"}
                                link={"download"}
                            />
                            <h2 className="formule_intro-subtitle"><label className="orange-color"> Turnkey</label> products</h2>
                            <article className="formule_intro-text">
                                Our white-label formulas offer a quick and easy solution  for incorporating high-quality food supplements and cosmetics into your catalogue.By opting for this solution, you gain access to pre-formulated, tried-and-tested products, ready to be marketed under your own brand.
                            </article>
                        </div>
                    )}
                    {!isMobile && <img className='formule_intro-container-img' src={marque_blanche_mobile} />}
                </section>
                <section className="formule_ourFormule-container">
                    <h3 className='formule_ourFormule-title'><label className="orange-color">OUR FORMULAS,</label> YOUR BRAND</h3>
                    <div className='formule_ourFormule-bloc-container'>
                        <div className='formule_ourFormule-text-container'>
                            <h3 className='formule_ourFormule-title-bloc'><label className="orange-color">our ready-to-use<br /></label> formulas</h3>
                            <article>We offer you a wide catalogue of tried and tested formulas that are ready to be marketed. These solutions, designed by our experts, meet current market expectations in terms of health and well-being. Each formula is developed with quality ingredients and complies with strict standards to guarantee effectiveness and compliance.</article>
                            <img className='formule_ourFormule-img' src={img_fiole} />
                        </div>
                        <p className='formule_ourFormule-plus'>+</p>
                        <div className='formule_ourFormule-text-container'>
                            <h3 className='formule_ourFormule-title-bloc'><label className="orange-color">your packaging</label></h3>
                            <article>We adapt each product to your image  through fully customised packaging. Whether it's a box, pillbox or sachet, we integrate your graphic elements to reflect your brand identity, while guaranteeing practicality, stability and optimum protection of the formulas.</article>
                            <img className='formule_ourFormule-img' src={img_packaging} />
                        </div>
                    </div>
                </section>
                <section className="fomrule_positifPoint-container">
                    <div className='fomrule_positifPoint-container2'>
                        <div className='formule_positifPoint-text-container'>
                            <h3 className='formule_positifPoint-title'><label className="orange-color">the advantages</label> of the <br />white-label formula</h3>
                            <article>We offer you a wide range of white-label food supplements and cosmetics tailored to market trends: well-being, immunity, digestion, beauty, energy, etc. Each product is formulated with carefully selected ingredients to guarantee effectiveness and customer satisfaction.</article>
                        </div>
                        <div className='formule_positifPoint-container'>
                            {content.map(([title, content], index) => (
                                <PositifPoint key={index} title={title} content={content} />
                            ))}
                        </div>
                    </div>
                </section>
                <div className="vertical-line"></div>
                <section className='formule_process_global-container'>
                    <h3 className='formule_process-title'>
                        our MANUFACTURING <label className='orange-color'>PROCESS</label><br />
                    </h3>
                    <p className='formule_process-subtitle'>
                    Notre méthode de création suit un processus rigoureux et rapide en quatre étapes clés, qui garantit <br/> un produit adapté et une qualité irréprochable.
                    </p>
                    <div className="formule_process_comp-container">
                        {isCarousel ? (
                            // Mode CAROUSEL (Mobile)
                            <div>
                                <div className="carousel_container">
                                    <Process
                                        img={process[currentIndexProcess][0]}
                                        title={process[currentIndexProcess][1]}
                                        content={process[currentIndexProcess][2]}
                                        index={currentIndexProcess + 1}  // Ajout de l'index
                                    />
                                </div>
                                <div className='formule_arrow_container--mobile'>
                                    <img className="carousel_arrow" alt="Flèche gauche" src={icon_arrow_back} onClick={handlePrevProcess} />
                                    <img className="carousel_arrow" alt="Flèche droite" src={icon_arrow_forward} onClick={handleNextProcess} />
                                </div>
                            </div>
                        ) : (
                            <div className='formule_process_comp-container2'>
                                {process.map(([img, title, content], index) => (
                                    <Process
                                        key={index}
                                        img={img}
                                        index={index + 1}
                                        title={title}
                                        content={content}
                                    />
                                ))}
                            </div>
                        )}
                    </div>
                </section>
                <div className="vertical-line"></div>
                <section className='formule_tabMockup_global-container'>
                    <h3 className='formule_tabMockup-title'>our white-label <br/><label className='orange-color'>products</label></h3>
                    <MockupTab />
                </section>
                <section className='formule_product_global-container'>
                    <div className='formule_product_catalogue-container'>
                        <h3 className='formule_product_catalogue-title'><label className='bold'>SEE ALL OUR FORMULAS</label><br /><label className='orange-color'>in our CATALOGUE</label></h3>
                        <button className='formule_product_catalogue-btn' onClick={downloadFile}>See our catalogue</button>
                    </div>
                    <MoreInfo 
                        label={"Contact us"}
                        link={"*"}
                    />
                </section>
                <section className='formule_otherProduct_global-container'>
                    <h3 className='formule_otherCategory-title'><label className='bold'>our</label><label className='orange-color'> ingredient categories</label></h3>
                    <OtherProduct
                        title1={"niosomes"}
                        subtitle1={"Cosmetics"}
                        img1={niosome}
                        link1={"/niosomes"}
                        title2={"Probiotiques & Postbiotiques"}
                        subtitle2={"Technologies VPRO® et PROLIPO®"}
                        img2={probiotique}
                        link2={"/probiotiques"}
                    />
                </section>
            </div>
        </div>
    );
}